"use client";

import "@ant-design/v5-patch-for-react-19";
import { App } from "antd";
import { SessionPreferenceSync } from "@/components/shell/SessionPreferenceSync";
import { I18nProvider } from "@/lib/i18n/I18nProvider";
import { ThemeProvider } from "@/lib/theme/ThemeProvider";
import { ActiveGuideProvider } from "@/providers/ActiveGuideProvider";
import { SessionProvider } from "@/providers/SessionProvider";

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <I18nProvider>
      <ThemeProvider>
        <App>
          <SessionProvider>
            <ActiveGuideProvider>
              <SessionPreferenceSync />
              {children}
            </ActiveGuideProvider>
          </SessionProvider>
        </App>
      </ThemeProvider>
    </I18nProvider>
  );
}
